import React from "react";

const RefreshButton = ({ refreshFloatRule, spinClass }) => {
  return (
    <div className="btn-group">
      <button className="refresh-float-rule">
        <span
          title="Refresh Float Rule"
          className={`fa fa-refresh float-reload ${spinClass}`}
          style={{
            fontSize: "large",
            margin: "10px",
          }}
          onClick={(e) => {
            e.preventDefault();
            refreshFloatRule();
          }}
        ></span>
      </button>
    </div>
  );
};

export default RefreshButton;
